import "./config";
import React from "react";
import ReactDOM from "react-dom/client";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { LottoContextProvider } from "./context/lottoContext";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "src/assets/scss/style.scss";
import "src/components/WageringStatus.css";
import setupLocatorUI from "@locator/runtime";

if (process.env.NODE_ENV === "development") {
  setupLocatorUI();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <LottoContextProvider>
      <App />
    </LottoContextProvider>
  </>
);

let wageringClientReloading = false;
const hadServiceWorker = Boolean(navigator.serviceWorker?.controller);
navigator.serviceWorker?.addEventListener("controllerchange", () => {
  if (hadServiceWorker && !wageringClientReloading) {
    wageringClientReloading = true;
    window.location.reload();
  }
});
serviceWorkerRegistration.register({
  onUpdate(registration) {
    registration.waiting?.postMessage({ type: "SKIP_WAITING" });
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
